import axios from "axios";

const registerApiRoute = async (data) => {
    const res = await axios({
        method: "POST",
        url: "/api/register",
        data,
        headers: {
            woocommerce: `Bearer ${data.recaptchaToken}`,
            appname: "Bearer next",
        },
    });
    return res;
};

export default registerApiRoute;
